<template lang="pug">
.counterComponent
  ui-svg-icon.icon(
    v-if="icon"
    :name="icon"
    :original-colors="true"
  )
  span.counter {{ value }}
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    icon: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="sass" scoped>
.counterComponent
  width: fit-content
  display: flex
  border-radius: 99em
  background-color: $cElements
  padding: $u
  box-shadow: 0 $u 0 $cDarkBackground
  margin-bottom: $u

  > .counter
    @include font('t16-demibold')
    margin: 0 3*$u
</style>
